import { GALLERY } from "@/data/content";
import OrnamentalDivider from "@/components/OrnamentalDivider";

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="max-w-2xl">
        <div className="stamp">Gallery</div>
        <h1 className="serif text-5xl md:text-6xl text-[#6E2638] mt-4">A city that looks up.</h1>
      </div>
      <OrnamentalDivider label="Melbourne CBD" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[220px]">
        {GALLERY.map((g, i) => (
          <div key={i} className={`overflow-hidden rounded-2xl ${g.span || ""}`} data-testid={`gallery-item-${i}`}>
            <img src={g.src} alt={g.alt}
                 className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
          </div>
        ))}
      </div>
    </div>
  );
}
